import { render, staticRenderFns } from "./baoxiuxinxi.vue?vue&type=template&id=a1fa8176&scoped=true&"
import script from "./baoxiuxinxi.vue?vue&type=script&lang=js&"
export * from "./baoxiuxinxi.vue?vue&type=script&lang=js&"
import style0 from "./baoxiuxinxi.vue?vue&type=style&index=0&id=a1fa8176&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fa8176",
  null
  
)

export default component.exports